export interface CreateUserResponse {
    registrationToken: string;
}
